module.exports = __webpack_public_path__ + "img/y9.08c3017c.webp";